import { Injectable } from "@angular/core";

/**
 * Notifies the React Native WebView host when the user enters/leaves the
 * full-page Community (NodeBB) embed, so the native shell can adjust its own
 * chrome/back-handling if needed. No-op outside the WebView (plain browser).
 */
@Injectable({ providedIn: "root" })
export class CommunityBridgeService {
  notifyOpen(): void {
    this.postToNative({ type: "COMMUNITY_OPEN" });
  }

  notifyClose(): void {
    this.postToNative({ type: "COMMUNITY_CLOSE" });
  }

  private postToNative(message: { type: string }): void {
    if (typeof window === "undefined" || !(window as any).ReactNativeWebView) {
      return;
    }
    (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
  }
}
